/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Which cover sheet leads the eFax/manual submission package:
 *   - `short`: system-generated summary cover sheet, no user input
 *   - `detailed`: user-reviewed cover sheet completed in the cover sheet step
 *   - `uploaded`: the user's own uploaded cover sheet document
 * 
 * @export
 */
export const PalAuthCoverSheetType = {
    Short: 'short',
    Detailed: 'detailed',
    Uploaded: 'uploaded',
} as const;
export type PalAuthCoverSheetType = typeof PalAuthCoverSheetType[keyof typeof PalAuthCoverSheetType];


export function instanceOfPalAuthCoverSheetType(value: any): boolean {
    for (const key in PalAuthCoverSheetType) {
        if (Object.prototype.hasOwnProperty.call(PalAuthCoverSheetType, key)) {
            if (PalAuthCoverSheetType[key as keyof typeof PalAuthCoverSheetType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function PalAuthCoverSheetTypeFromJSON(json: any): PalAuthCoverSheetType {
    return PalAuthCoverSheetTypeFromJSONTyped(json, false);
}

export function PalAuthCoverSheetTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): PalAuthCoverSheetType {
    return json as PalAuthCoverSheetType;
}

export function PalAuthCoverSheetTypeToJSON(value?: PalAuthCoverSheetType | null): any {
    return value as any;
}

export function PalAuthCoverSheetTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): PalAuthCoverSheetType {
    return value as PalAuthCoverSheetType;
}

